var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// model
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { RequestManagerService } from 'src/app/shared/service/request-manager.service';
import * as i0 from "@angular/core";
import * as i1 from "../http-header.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../request-manager.service";
var SearchWorkerService = /** @class */ (function (_super) {
    __extends(SearchWorkerService, _super);
    function SearchWorkerService(header, http, requestManager, injector) {
        var _this = _super.call(this, header, http, requestManager, injector) || this;
        // サービス毎に初期値を設定する
        _this.initPage = { page: 1 };
        _this.initPerPage = { perPage: 50 }; // TODO: 未使用（API側で200件ずつ取得するようになっているので使用できるようにすべき）
        _this.selfServiceName = 'SearchWorkerService';
        return _this;
    }
    SearchWorkerService.prototype.doSearch = function (id, sortParams, currentSearchCondition) {
        return _super.prototype.requestPost.call(this, 'api/v1/workers', this.getSearchParameters(sortParams, currentSearchCondition));
    };
    SearchWorkerService.prototype.searchFocusMail = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/user_focus_mails?mail_side=worker', this.getSearchParameters());
    };
    SearchWorkerService.prototype.createOrDeleteFocusMail = function (focus_info) {
        return _super.prototype.requestPost.call(this, 'api/v1/user_focus_mails', focus_info);
    };
    SearchWorkerService.prototype.getSearchKeyword = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/workers/index_search_keyword', this.getSearchParameters());
    };
    SearchWorkerService.prototype.getBestMails = function () {
        return _super.prototype.requestGet.call(this, 'api/v1/workers/best_mails');
    };
    SearchWorkerService.ngInjectableDef = i0.defineInjectable({ factory: function SearchWorkerService_Factory() { return new SearchWorkerService(i0.inject(i1.HttpHeaderService), i0.inject(i2.HttpClient), i0.inject(i3.RequestManagerService), i0.inject(i0.INJECTOR)); }, token: SearchWorkerService, providedIn: "root" });
    return SearchWorkerService;
}(SearchService));
export { SearchWorkerService };
